export const SET_ENVIRONMENT = 'Set_Environment';
export const SET_AUTH_TOKEN = 'Set_Auth_Token';
export const POPULATE_AND_TRACK_MAP = 'Populate_And_Track_Map';
export const PROCESS_LAYER_DATA_CHANGE_EVENTS = 'Process_Layer_Data_Change_Events';
export const POPULATE_AND_TRACK_LAYER = 'Populate_And_Track_Layer';
export const PROCESS_CONNECTION_STATS = 'Process_Connection_Stats';
export const SET_FLOOR_FILTER_FOR_LAYERS = 'Set_Floor_Filter_For_Layers';
export const PROCESS_DATASET_CHANGE_EVENT = 'Process_Dataset_Change_Event';
export const PROCESS_WORKFLOW_CHANGE_EVENT = 'Process_Workflow_Change_Event';
export const START_TRACK_FLIGHT_LAYER_CHANGES = 'Start Track Flight Layer Changes';
export const STOP_TRACK_FLIGHT_LAYER_CHANGES = 'Stop Track Flight Layer Changes';
export const SET_MAP_POSITION_AND_ZOOM = 'Set Map Position and Zoom';
export const PROCESS_VMS_DATA_CHANGE_EVENT = 'Process_Vms_Change_Event';
export const OPEN_VMS_CONNECTION = 'Open_Vms_Connection';
export const CLOSE_VMS_CONNECTION = 'Close_Vms_Connection';
export const SEND_VMS_REQUEST = 'Send_Vms_Request';
export const PROCESS_TEMPORARY_LAYER_TRACKING = 'Process_Temporary_Layer_Tracking';